import React from 'react';
import {Flex, Icon, ListItem, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {useHover} from '../../../../../hooks/useHover';
import styles from './Trigger/styles.module.scss';

type Props = {
    item: {title: string; desc: string};
    onItemClick: (item: any) => void;
    index: number;
    currentFocusedIndex: number;
    handleShowHelp: (e, desc: string) => void;
};

export const AutomationsDropdownItem = ({
    item,
    onItemClick,
    index,
    currentFocusedIndex,
    handleShowHelp
}: Props) => {
    const {setRef, isHovering} = useHover();

    return (
        <ListItem
            componentClasses={styles.listItem}
            key={item.title}
            ref={setRef}
            onClick={() => onItemClick(item)}
            isFocused={currentFocusedIndex === index}
            isActive={false}
        >
            <Flex justifyContent="space-between">
                <Flex justifyContent="flex-start">
                    <Text tag="div" skin="paragraph-1">
                        {item.title}
                    </Text>
                    {isHovering && (
                        <Icon
                            icon={PriorityIcon.help}
                            onClick={e => handleShowHelp(e, item.desc)}
                        />
                    )}
                </Flex>
            </Flex>
        </ListItem>
    );
};
